const MS_PER_MINUTE = 60_000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

function pluralize(count: number, singular: string, plural: string): string {
  return count === 1 ? singular : plural;
}

export function formatReviewDateRelative(isoDate: string): string {
  try {
    const reviewDate = new Date(isoDate);

    if (Number.isNaN(reviewDate.getTime())) {
      return isoDate;
    }

    const diffMs = Date.now() - reviewDate.getTime();
    const diffMinutes = Math.floor(diffMs / MS_PER_MINUTE);
    const diffHours = Math.floor(diffMs / MS_PER_HOUR);
    const diffDays = Math.floor(diffMs / MS_PER_DAY);

    if (diffMinutes === 0) { return 'gerade eben'; }

    if (diffHours === 0) {
      return pluralize(diffMinutes, 'vor 1 Minute', `vor ${diffMinutes} Minuten`);
    }

    if (diffDays === 0) {
      return pluralize(diffHours, 'vor 1 Stunde', `vor ${diffHours} Stunden`);
    }

    if (diffDays <= 6) {
      return pluralize(diffDays, 'gestern', `vor ${diffDays} Tagen`);
    }

    return [
      reviewDate.getDate(),
      reviewDate.getMonth() + 1,
      reviewDate.getFullYear(),
    ].join('.');
  } catch {
    return isoDate;
  }
}
